module.exports = __webpack_public_path__ + "img/63.3d3dc2e4.jpg";